import { 
    apiCaptchaValidate, 
    apiValidateEmail,
    apiValidatePhone 
} from '@/api/register'

export function validate_email(rule, value, callback) {
    // 邮箱
    if (!value) {
        return callback(new Error(this.$t('Validate.Email.IsNull')))
    }

    if (value.length > 100) {
        return callback(new Error(this.$t('Validate.StringLength.Length100')))
    }

    // 邮箱格式验证
    const reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,12})+$/
    if (!reg.test(value)) {
        return callback(new Error(this.$t('Validate.Email.IsCorrect')))
    }

    // 验证邮箱是否注册过
    apiValidateEmail({ email: value })
        .then(res => {
            if (res.code === 200) {
                callback()
            }
        }).catch(err => {
            if (err.code === 556){
                return callback(new Error(this.$t('Validate.Email.IsRegistered')))
            } else {
                return callback(new Error(this.$t('Validate.Email.IsExists')))
            }
        })
}

export function validate_password(rule, value, callback) {
    // 密码
    if (!value) {
        return callback(new Error(this.$t('Validate.Password.IsNull')))
    }

    const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).[^\s]{5,19}$/ //密码校验
    if (!reg.test(value)) {
        return callback(new Error(this.$t('Validate.Password.IsCorrect')))
    }

    callback()
}

export function validate_confirmPassword(rule, value, callback) {
    // 确认密码
    if (!value) {
        return callback(new Error(this.$t('Validate.ConfirmPassword.IsNull')))
    }
    let password = (this.form && this.form.password) || ''
    if (value !== password) {
        return callback(new Error(this.$t('Validate.ConfirmPassword.NotSame')))
    }
    callback()
}

export function validate_companyNameZh(rule, value, callback) {
    // 公司中文名
    if (!value) {
        return callback(new Error(this.$t('Validate.CompanyNameZh.IsNull')))
    }

    if (value.length > 100) {
        return callback(new Error(this.$t('Validate.StringLength.Length100')))
    }

    callback()
}

export function validate_companyNameEn(rule, value, callback) {
    // 公司英文名

    if (!value) {
        return callback(new Error(this.$t('Validate.CompanyNameEn.IsNull')))
    }

    if (value.length > 200) {
        return callback(new Error(this.$t('Validate.StringLength.Length200')))
    }
    
    //仅支持英文字母、数字、逗号、点、下划线、横线、空格
    const reg = /^([a-z_A-Z-., +0-9]+)$/
    if (!reg.test(value)) {
        return callback(new Error(this.$t('Validate.CompanyNameEn.IsCorrect')))
    }

    callback()
}

export function validate_departmentName(rule, value, callback) {
    // 部门
    if (!value) {
        return callback(new Error(this.$t('Validate.DepartmentName.IsNull')))
    }

    if (value.length > 20) {
        return callback(new Error(this.$t('Validate.StringLength.Length20')))
    }

    callback()
}

export function validate_positionName(rule, value, callback) {
    // 职位
    if (!value) {
        return callback(new Error(this.$t('Validate.PositionName.IsNull')))
    }

    if (value.length > 20) {
        return callback(new Error(this.$t('Validate.StringLength.Length20')))
    }

    callback()
}

export function validate_uname(rule, value, callback) {
    // 姓名
    if (!value) {
        return callback(new Error(this.$t('Validate.Name.IsNull')))
    }

    if (value.length > 20) {
        return callback(new Error(this.$t('Validate.StringLength.Length20')))
    }

    callback()
}

export function validate_country(rule, value, callback) {
    // 国家
    if (!value) {
        return callback(new Error(this.$t('Validate.Region.CountryIsNull')))
    }

    callback()
}

export function validate_region(rule, value, callback) {
    // 所在区域
    if(this.form.country === '0'){
        if (!value) {
            return callback(new Error(this.$t('Validate.Region.IsNull')))
        }
    }

    callback()
}

export function validate_phone(rule, value, callback) {
    // 手机号
    if (!value) {
        return callback(new Error(this.$t('Validate.Phone.IsNull')))
    }

    let isChinaMainland = this.form && this.form.region && (this.regionValueFormat(this.form.region) !== '1')
    const reg = /^1[0-9]{10}$/ // 对中国大陆地区手机号进行验证
    if (isChinaMainland) {
        if(!reg.test(value)){
            return callback(new Error(this.$t('Validate.Phone.PhoneNumber')))
        }
    }else{
        if(value.length > 20){
            return callback(new Error(this.$t('Validate.StringLength.Length20'))) 
        }
    }

    // 验证手机号是否被注册过
    apiValidatePhone({ phone: value })
        .then(res => {
            if (res.code === 200) {
                callback()
            }
        }).catch(err => {
            if (err.code === 554){
                return callback(new Error(this.$t('Validate.Phone.IsRegistered')))
            } else {
                return callback(new Error(this.$t('Validate.Phone.IsExists')))
            }
        })
}

export function validate_captcha_img(rule, value, callback) {
    // 图形验证码
    let email = (this.form && this.form.email) || (this.$parent.userInfo && this.$parent.userInfo.email) || ''
    if (!value) {
        return callback(new Error(this.$t('Validate.Captcha.IsNull')))
    }
    const data = {
        captcha: value,
        email: email,
    }
    apiCaptchaValidate(data).then(res => {
        if (res.data.status === 200) {
            callback()
        } else {
            return callback(new Error(this.$t('Validate.Captcha.IsError')))
        }
    })
}

export function validate_captcha_sms(rule, value, callback) {
    // 短信验证码
    if (!value) {
        return callback(new Error(this.$t('Validate.SmsCaptcha.IsNull')))
    }
    if(value && value.length < 6){
        return callback(new Error(this.$t('Validate.SmsCaptcha.minLength')))
    }
    callback()
}

export function validate_refereeName(rule, value, callback) {
    // 推荐人
    // if (!value) {
    //   return callback(new Error(this.$t('Validate.RefereeName.IsNull')))
    // }

    if (value && value.length > 20) {
        return callback(new Error(this.$t('Validate.StringLength.Length20')))
    }

    callback()
}

export function validate_remark(rule, value, callback) {
    // 备注
    // if (!value) {
    //   return callback(new Error(this.$t('Validate.Remark.IsNull')))
    // }

    if (value && value.length > 200) {
        return callback(new Error(this.$t('Validate.StringLength.Length200')))
    }

    callback()
}
